import { useRef } from 'react';
import { images } from '../../Constants/ImageUrls';
import { createRippleEffectRelative } from '../../Utils/helper';
import { GotoTop } from './TopBannerwithtext/styled';

export default function GotoTopButton(props) {
  const { scrollUp, showGoTop } = props;
  const goTopRipple = useRef(null);
  return (
    <>
      {showGoTop === 'goTopShow' && (
        <GotoTop
          className={showGoTop}
          ref={goTopRipple}
          onClick={(event) => {
            createRippleEffectRelative(event, goTopRipple.current);
            scrollUp();
          }}
        >
          <img
            // src="/images/white_arrow_up.png"
            src={images.white_arrow_Up}
            alt="gotoparrow"
            width={'20px'}
            height={'20px'}
          />{' '}
          Go to Top
        </GotoTop>
      )}
    </>
  );
}
